// Author Lin
// Date 2021-11-27 14:02:36

class MintalMesPrdPowerStationRecord {
    constructor({
            id = null,
            recordTime = '',
            shiftId = '',
            shiftName = '',
            meterId = '',
            meterName = '',
            meterReading = '',
            recorderId = '',
            recorder = '',
            reviewerId = '',
            reviewer = '',
            remark = ''}
    = {}) {
        this.id = id;
        this.recordTime = recordTime;
        this.shiftId = shiftId;
        this.shiftName = shiftName;
        this.meterId = meterId;
        this.meterName = meterName;
        this.meterReading = meterReading;
        this.recorderId = recorderId;
        this.recorder = recorder;
        this.reviewerId = reviewerId;
        this.reviewer = reviewer;
        this.remark = remark;
    }
    }
    
    function newEntity() {
    return new MintalMesPrdPowerStationRecord();
    }
    
        function gridFields() {
        return Object.freeze([
            {
            key: 'id',
            label: 'label.mintal.prd.mintalMesPrdPowerStationRecord.grid.id',
            sortable: true,
                isDetail: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'recordTime',
            label: 'label.mintal.prd.mintalMesPrdPowerStationRecord.grid.recordTime',
            sortable: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'locationName',
            label: 'label.mintal.prd.mintalMesPrdPowerStationRecord.grid.locationName',
            sortable: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'generatorName',
            label: 'label.mintal.prd.mintalMesPrdPowerStationRecord.grid.generatorName',
            sortable: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'shiftId',
            label: 'label.mintal.prd.mintalMesPrdPowerStationRecord.grid.shiftId',
            sortable: true,
                isDetail: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'shiftName',
            label: 'label.mintal.prd.mintalMesPrdPowerStationRecord.grid.shiftName',
            sortable: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'meterId',
            label: 'label.mintal.prd.mintalMesPrdPowerStationRecord.grid.meterId',
            sortable: true,
                isDetail: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'meterName',
            label: 'label.mintal.prd.mintalMesPrdPowerStationRecord.grid.meterName',
            sortable: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'meterReading',
            label: 'label.mintal.prd.mintalMesPrdPowerStationRecord.grid.meterReading',
            sortable: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'recorderId',
            label: 'label.mintal.prd.mintalMesPrdPowerStationRecord.grid.recorderId',
            sortable: true,
                isDetail: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'recorder',
            label: 'label.mintal.prd.mintalMesPrdPowerStationRecord.grid.recorder',
            sortable: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'reviewerId',
            label: 'label.mintal.prd.mintalMesPrdPowerStationRecord.grid.reviewerId',
            sortable: true,
                isDetail: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'reviewer',
            label: 'label.mintal.prd.mintalMesPrdPowerStationRecord.grid.reviewer',
            sortable: true,
                isDetail: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'remark',
            label: 'label.mintal.prd.mintalMesPrdPowerStationRecord.grid.remark',
            sortable: true,
                isDetail: true,
            form: {
            type: 'textarea'
            }
            }
        ])}
    
    const filter = {
        idFilter : '',
        idListFilter : [],
        recordTimeRteFilter : '',
        recordTimeLteFilter : '',
        shiftIdFilter : '',
        shiftNameFilter : '',
        meterIdFilter : '',
        meterNameFilter : '',
        meterReadingFilter : '',
        recorderIdFilter : '',
        recorderFilter : '',
        reviewerIdFilter : '',
        reviewerFilter : ''
    };
    
    const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));
    
    const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));
    
    const filterConfigs = [
            {
            key: 'recordTimeRteFilter',
            label: 'label.mintal.prd.mintalMesPrdPowerStationRecord.filter.recordTimeRte',
            disabled: false,
            form: {
            type: 'datetimepicker'
                    }
            },
            {
            key: 'recordTimeLteFilter',
            label: 'label.mintal.prd.mintalMesPrdPowerStationRecord.filter.recordTimeLte',
            disabled: false,
            form: {
            type: 'datetimepicker'
                    }
            },
            {
            key: 'shiftNameFilter',
            label: 'label.mintal.prd.mintalMesPrdPowerStationRecord.filter.shiftName',
            disabled: false,
            form: {
            type: 'entityModalSelect'
                ,entity: 'imfMstShift'
                ,correspondingField: 'name'
                ,fieldsBindingByEntityModalSelected: '{"shiftId":"id"}'
                    }
            },
            {
            key: 'meterNameFilter',
            label: 'label.mintal.prd.mintalMesPrdPowerStationRecord.filter.meterName',
            disabled: false,
            form: {
            type: 'entityModalSelect'
                ,entity: 'mintalMesMstPowerStationMeter'
                ,correspondingField: 'meterName'
                ,fieldsBindingByEntityModalSelected: '{"meterId":"id"}'
                    }
            },
            {
            key: 'recorderFilter',
            label: 'label.mintal.prd.mintalMesPrdPowerStationRecord.filter.recorder',
            disabled: false,
            form: {
            type: 'entityModalSelect'
                ,entity: 'emAclUser'
                ,correspondingField: 'name'
                ,fieldsBindingByEntityModalSelected: '{"recorderId":"id"}'
                    }
            },
    ];
    
    
        const entityFormConfigs = [
            {
            key: 'recordTime',
            label: 'label.mintal.prd.mintalMesPrdPowerStationRecord.entity.recordTime',
            sortable: true,
            disabled: false,
            form: {
            type: 'datetimepicker'
                    }
            },
            {
            key: 'shiftName',
            label: 'label.mintal.prd.mintalMesPrdPowerStationRecord.entity.shiftName',
            sortable: true,
            disabled: false,
            form: {
            type: 'entityModalSelect'
                ,entity: 'imfMstShift'
                ,correspondingField: 'name'
                ,fieldsBindingByEntityModalSelected: '{"shiftId":"id"}'
                    }
            },
            {
            key: 'meterName',
            label: 'label.mintal.prd.mintalMesPrdPowerStationRecord.entity.meterName',
            sortable: true,
            disabled: false,
            form: {
            type: 'entityModalSelect'
                ,entity: 'mintalMesMstPowerStationMeter'
                ,correspondingField: 'meterName'
                ,fieldsBindingByEntityModalSelected: '{"meterId":"id"}'
                    }
            },
            {
            key: 'meterReading',
            label: 'label.mintal.prd.mintalMesPrdPowerStationRecord.entity.meterReading',
            sortable: true,
            disabled: false,
            form: {
            type: 'inputNumber'
                    }
            },
            {
            key: 'recorder',
            label: 'label.mintal.prd.mintalMesPrdPowerStationRecord.entity.recorder',
            sortable: true,
            disabled: false,
            form: {
            type: 'entityModalSelect'
                ,entity: 'emAclUser'
                ,correspondingField: 'name'
                ,fieldsBindingByEntityModalSelected: '{"recorderId":"id"}'
                    }
            },
            {
            key: 'remark',
            label: 'label.mintal.prd.mintalMesPrdPowerStationRecord.entity.remark',
            sortable: true,
            disabled: false,
            form: {
            type: 'textarea'
                    }
            }
    ]
    
    export {MintalMesPrdPowerStationRecord, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
    , filterConfigs
    
    
    }
    